import FormattedMessage from 'I18n/components/FormattedMessage';
import { Header as FoundationsHeader } from 'foundations-components/transitional/components/Header';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Header = ({
  branding
}) => {
  const logoUrl = branding.logoUrl;
  const companyName = branding.companyName;
  return /*#__PURE__*/_jsx(FoundationsHeader, {
    flush: true,
    use: "condensed",
    paddingBlock: "400",
    "data-test-id": "page-header",
    title: logoUrl ? /*#__PURE__*/_jsx(Image, {
      src: logoUrl,
      responsive: false,
      blockSize: "55px"
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: companyName || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.checkoutHeader"
      })
    })
  });
};
export default Header;